/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RptSalPlannedOutputDtoFromJSON, RptSalPlannedOutputDtoToJSON, } from './RptSalPlannedOutputDto';
import { RptSalPlannedTotaleMeseDtoFromJSON, RptSalPlannedTotaleMeseDtoToJSON, } from './RptSalPlannedTotaleMeseDto';
/**
 * Check if a given object implements the RptSalPlannedSearchResponseDto interface.
 */
export function instanceOfRptSalPlannedSearchResponseDto(value) {
    return true;
}
export function RptSalPlannedSearchResponseDtoFromJSON(json) {
    return RptSalPlannedSearchResponseDtoFromJSONTyped(json, false);
}
export function RptSalPlannedSearchResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'results': json['results'] == null ? undefined : (json['results'].map(RptSalPlannedOutputDtoFromJSON)),
        'totaliMese': json['totaliMese'] == null ? undefined : (json['totaliMese'].map(RptSalPlannedTotaleMeseDtoFromJSON)),
        'totaleGenerale': json['totaleGenerale'] == null ? undefined : json['totaleGenerale'],
    };
}
export function RptSalPlannedSearchResponseDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'results': value['results'] == null ? undefined : (value['results'].map(RptSalPlannedOutputDtoToJSON)),
        'totaliMese': value['totaliMese'] == null ? undefined : (value['totaliMese'].map(RptSalPlannedTotaleMeseDtoToJSON)),
        'totaleGenerale': value['totaleGenerale'],
    };
}
